import React, { useState,useEffect,memo } from 'react';
import './mediaselectbox.scss';
function MediaSelectBox(props){
    const [selectedOption2, setSelectedOption2] = useState("");
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setSelectedOption2(props.defaultValue);
    }, [props.defaultValue]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const handleChange = (e) => {
        setSelectedOption2(e.target.value)
        props.setSelectedSelect2Value(e.target.value)
    }
    return (
        <>
            <div className="dropdown-schedule">
                <select className={`${props.calss} dropdown-media upload_media_field`} name="pets" id={props.id}>
                    {props.menuItem && props.menuItem.map((menu) => (
                        <option value={menu.value}>{menu.label}</option>
                    ))}
                </select>
            </div>
        </>
    );
}

export default memo(MediaSelectBox)